/**
 * Configuration object about the user.
 * Provides paths to default pictures in case of a "Standard" game.
 * If "Facebook" is used, those pictures are not loaded unless the user has no FB picture at all.
 * The `height` is the camera's `y` position in cm.
 */
const user = {
	height: 155,
	defaultName: 'Vous',
	defaultPictures: [
		'./textures/defaultUserPhotos/profil_1.jpg',
		'./textures/defaultUserPhotos/profil_2.jpg',
		'./textures/defaultUserPhotos/profil_3.jpg',
		'./textures/defaultUserPhotos/profil_4.jpg',
		'./textures/defaultUserPhotos/profil_5.jpg',
		'./textures/defaultUserPhotos/profil_6.jpg',
		'./textures/defaultUserPhotos/profil_7.jpg',
		'./textures/defaultUserPhotos/profil_8.jpg',
		'./textures/defaultUserPhotos/profil_9.jpg',
		'./textures/defaultUserPhotos/profil_10.jpg'
	],
	defaultProfilPicture: './textures/defaultUserPhotos/defaultProfilPicture.jpg',
	defaultRank: 5
}

export default user
